const BADGE_PATH =
  'M22.9178 19.0278L26.8066 15.1389L22.9178 11.25M26.8066 15.1389L13.1955 15.1389M17.0844 20.9722L13.1955 24.8611L17.0844 28.75M13.1955 24.8611L26.8066 24.8611';
const GLYPH_PATH =
  'M15.0926 11.0741L19.1296 7.03704L15.0926 3M19.1296 7.03704L5 7.03704M9.03704 13.0926L5 17.1296L9.03704 21.1667M5 17.1296L19.1296 17.1296';

function IconMarketplace({
  size = 40,
  color = '#FFFFFF',
  backgroundColor = '#6A4EDE',
  withBackground = true,
}: {
  size?: number;
  color?: string;
  backgroundColor?: string;
  withBackground?: boolean;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox={withBackground ? '0 0 40 40' : '0 0 24 24'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {withBackground && (
        <rect width="39.9992" height="39.9992" rx="19.9996" fill={backgroundColor} />
      )}
      <path
        d={withBackground ? BADGE_PATH : GLYPH_PATH}
        stroke={color}
        strokeWidth={withBackground ? '2.86364' : '2.5'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
IconMarketplace.displayName = 'IconMarketplace';

export { IconMarketplace };
